import { render } from "./SearchItem.vue?vue&type=template&id=54fc86a8"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"

import "./SearchItem.vue?vue&type=style&index=0&id=54fc86a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__